<template>
  <page-section :title="$t('ProfileTags_Title')">
    <rest-list :payload="fetchEndpoint" :loading="!applicationsLoaded">
      <rest-list-column-date
        :sortable="true"
        :prop="clickhouse ? 'timestamp' : 'create_time'"
        :unix="!clickhouse"
        :title="$t('ProfileTags_Field_CreateTime')"
        :width="200"
      />

      <rest-list-column
        :prop="clickhouse ? 'source_tag_name' : 'tag_title'"
        :title="$t('ProfileTags_Field_Tag')"
        :sortable="false"
      />

      <rest-list-column
        v-if="!clickhouse"
        prop="metric_title"
        :title="$t('ProfileTags_Field_Metric')"
        :sortable="false"
      />

      <rest-list-column
        prop="value"
        :title="$t('ProfileTags_Field_Value')"
        :formatter="personalDataFormatter"
        :sortable="false"
      />

      <rest-list-column-enum
        :prop="clickhouse ? 'source_application_id' : 'application_id'"
        :title="$t('ProfileTags_Field_Application')"
        :key="applicationsLoaded"
        :enum="applications"
        :width="200"
        :sortable="false"
      />

      <rest-list-column
        prop="device_id"
        :title="$t('ProfileTags_Field_DeviceId')"
        :route="rowClickDeviceIdRoute"
        :width="200"
        :sortable="false"
      />
    </rest-list>
  </page-section>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import PageSection from '@/common/components/page/PageSection'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'TagsListPage',

  components: {
    PageSection,
    RestListColumnDate,
    RestList,
    RestListColumnEnum,
    RestListColumn
  },

  data() {
    return {
      applications: {},
      applicationsLoaded: false
    }
  },

  created() {
    new RestApiPaginator(this.optionsEndpoint).fetchAllPages().then(data => {
      data.forEach(val => {
        this.applications[val.id] = val.name
      })
      this.applicationsLoaded = true
    })
  },

  computed: {
    clickhouse() {
      return $hasFeature('shouldReadTagsFromClickhouse')
    },

    optionsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'applications',
        params: {}
      })
    },

    fetchEndpoint() {
      if (this.clickhouse) {
        return projectEndpoint({
          method: 'get',
          url: `profiles/${this.$route.query.profile_num}/tag-hits-clickhouse`
        })
      }
      return projectEndpoint({
        method: 'get',
        url: `tag-hits`,
        params: {
          expand: 'tag_title,metric_title,application_title',
          profile_id: this.$route.query.profile_id
        }
      })
    }
  },

  methods: {
    rowClickDeviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: row.device_id
        }
      })
    },

    personalDataFormatter(value) {
      if (!value) {
        return '-'
      } else if (this.$can('UserPersonalData::Read')) {
        return value
      } else {
        return '******'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/pages/TagsListPage.vue